// extracted by mini-css-extract-plugin
export var scrollableTableHeadCell = "scrollable-table__head-cell_biYirQWF8B9siy6lpbDP";
export var scrollableTableShownHeadCell = "scrollable-table__shown-head-cell_bVZk4oTtC3Bjmkp2z6in";